document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.collapsible-toggle');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            const index = button.id.split('-')[1];
            const descriptionContainer = document.getElementById(`seo_description-${index}`);
            const isCollapsed = button.getAttribute('aria-expanded') === 'false';
            const collapsedText = descriptionContainer.getAttribute('data-collapsed-text');
            const expandedText = descriptionContainer.getAttribute('data-expanded-text');

            descriptionContainer.innerHTML = isCollapsed ? expandedText : collapsedText;
            descriptionContainer.appendChild(button.parentElement);

            button.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
            button.textContent = isCollapsed ? button.getAttribute('data-expanded-label') : button.getAttribute('data-collapsed-label');
        });
    });
});